import React, { useState, useEffect } from "react";
import axios from "axios";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";


function AddUserDevices() {
  const [formData, setFormData] = useState({
    device_id: "",
    button_state: "",
    current_time: "",
    last_off_reason: "",
    last_off_time: "",
    last_on_time: "",
    last_on_reason: "",
    p1: "",
    relay_on_time: "",
    switch_state: "",
    water_level: "",
    wifi_reset: "",
    user_id: "",
    image: null,
  });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarType, setSnackbarType] = useState("success");
  const [users, setUsers] = useState([]);
  const [message, setMessage] = useState("");
  const [devices, setDevices] = useState([]);

  //for user id
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/allusers`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUsers(res.data.data || []);
      } catch (error) {
        console.error("Failed to fetch users", error);
        setUsers([]);
        setSnackbarType("error");
        setSnackbarOpen(true);
      }
    };

    fetchUsers();
  }, []);



  useEffect(() => {
    const fetchDevices = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/get-devices`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log("Fetched devices:", res.data);

        setDevices(res.data.data || []);

      } catch (error) {
        console.error("Failed to fetch devices", error);

        setDevices([]);

      }
    };

    fetchDevices();
  }, []);


  const handleChange = (event) => {
    const { name, value, files } = event.target;
    if (files) {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const token = localStorage.getItem("access_token");
    if (!token) {
      setMessage("Access token not found. Please log in again.");
      setSnackbarType("error");
      setSnackbarOpen(true);
      return;
    }

    try {
      const data = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        if (key === "wifi_reset") {
          data.append(key, value === "1" || value === 1 ? 1 : 0);
        }
        else if (value !== null && value !== "") {
          data.append(key, value);
        }
      });

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/addadmin-devices`,
        data,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success === false) {
        setMessage(response.data.message);
        setSnackbarType("error");
        setSnackbarOpen(true);
        return;
      }

      setMessage("Device added successfully!");
      setSnackbarType("success");
      setSnackbarOpen(true);
      console.log("added devices", response.data);
      setFormData({
        device_id: "",
        button_state: "",
        current_time: "",
        last_off_reason: "",
        last_off_time: "",
        last_on_time: "",
        last_on_reason: "",
        p1: "",
        relay_on_time: "",
        switch_state: "",
        water_level: "",
        wifi_reset: "",
        user_id: "",

        image: null,
      });
    } catch (error) {
      console.error("Error adding device:", error);
      setMessage(
        error.response?.data?.message || "Failed to add device. Please try again."
      );
      setSnackbarType("error");
      setSnackbarOpen(true);
    }
  };
  const handleSnackbarClose = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };


  return (
    <DashboardLayout>
      <DashboardNavbar absolute isMini />
      <MDBox mt={8} mb={8}>
        <Grid container justifyContent="center">
          <Grid item xs={12} md={12} lg={10}>
            <Card>
              <MDBox p={3}>
                <MDTypography variant="h5" fontWeight="medium" mb={3}>
                  Add User Device
                </MDTypography>

                <form onSubmit={handleSubmit}>
                  <Grid container spacing={2}>
                    {/* First Row: 2 Columns */}
                    <Grid container item spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <MDTypography fontWeight="regular" display="block" style={{ fontSize: "0.75rem", marginBottom: "8px", color: "#555" }}>
                          Device ID
                        </MDTypography>
                        <select
                          name="device_id"
                          value={formData.device_id}
                          onChange={handleChange}
                          style={{
                            width: "100%",
                            padding: "8px 12px",
                            fontSize: "0.9rem",
                            borderRadius: "6px",
                            border: "1.5px solid #ccc",
                            backgroundColor: "#fafafa",
                            cursor: "pointer",
                          }}
                        >
                          <option value="" disabled>Select Device ID</option>
                          {devices.length > 0 ? (
                            devices.map((device) => (
                              <option key={device.device_id} value={device.device_id}>
                                {device.device_id}
                              </option>
                            ))
                          ) : (
                            <option disabled>No devices available</option>
                          )}
                        </select>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <MDTypography fontWeight="regular" display="block" style={{ fontSize: "0.75rem", marginBottom: "8px", color: "#555" }}>
                          User ID
                        </MDTypography>
                        <select
                          name="user_id"
                          value={formData.user_id}
                          onChange={handleChange}
                          style={{
                            width: "100%",
                            padding: "8px 12px",
                            fontSize: "0.9rem",
                            borderRadius: "6px",
                            border: "1.5px solid #ccc",
                            backgroundColor: "#fafafa",
                            cursor: "pointer",
                          }}
                        >
                          <option value="" disabled>Select User ID</option>
                          {users.length > 0 ? (
                            users.map((user) => (
                              <option key={user.id} value={user.id}>
                                {user.name}
                              </option>
                            ))
                          ) : (
                            <option disabled>No users available</option>
                          )}
                        </select>
                      </Grid>
                    </Grid>

                    {/* Second Row: 4 Columns */}
                    <Grid container item spacing={2}>

                      {[
                        "button_state",
                        "current_time",
                        "p1",
                        "last_off_time",
                      ].map((field) => (
                        <Grid item xs={12} sm={6} md={3} key={field}>
                          <MDInput
                            label={field.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}
                            name={field}
                            fullWidth
                            value={formData[field]}
                            onChange={handleChange}
                          />
                        </Grid>
                      ))}
                    </Grid>

                    {/* Remaining Fields */}
                    {[
                      "last_on_time",
                      "last_on_reason",
                      "last_off_reason",
                      "relay_on_time",
                      "switch_state",
                      "water_level",
                    ].map((field) => (
                      <Grid item xs={12} sm={6} md={4} key={field}>
                        <MDInput
                          label={field.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}
                          name={field}
                          fullWidth
                          value={formData[field]}
                          onChange={handleChange}
                        />
                      </Grid>
                    ))}

                    {/* WiFi Reset */}
                    <Grid item xs={12} sm={6} md={6}>
                      <MDTypography fontWeight="regular" style={{ fontSize: "0.75rem" }}>
                        WiFi Reset
                      </MDTypography>
                      <select
                        name="wifi_reset"
                        value={formData.wifi_reset}
                        onChange={handleChange}
                        style={{
                          width: "100%",
                          padding: "8px",
                          borderRadius: "5px",
                          border: "1px solid #ccc",
                        }}
                      >
                        <option value="">Select</option>
                        <option value="1">True</option>
                        <option value="0">False</option>
                      </select>
                    </Grid>

                    {/* Image */}
                    <Grid item xs={12} sm={6} md={6}>
                      <MDTypography fontWeight="regular" style={{ fontSize: "0.75rem" }}>
                        Image
                      </MDTypography>
                      <input
                        type="file"
                        name="image"
                        accept="image/*"
                        onChange={handleChange}
                        style={{
                          width: "100%",
                          padding: "8px",
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                        }}
                      />
                    </Grid>
                  </Grid>
                  <MDBox mt={4} mb={1}>
                    <MDButton variant="gradient" color="info" type="submit" fullWidth>
                      Add Device
                    </MDButton>
                  </MDBox>
                </form>

              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleSnackbarClose}
          severity={snackbarType}
          sx={{ width: "100%" }}
        >
          {message}
        </MuiAlert>
      </Snackbar>
      <Footer />
    </DashboardLayout>
  );
}

export default AddUserDevices;
